import * as types from "../types";

const INITIAL_STATE = {
  globalLeavelist: [],
  globalLeavedetails: [],
};

const globalLeaveReducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CREATE_GLOBAL_LEAVE:
      // Optionally append newly created leave to list
      return {
        ...state,
        globalLeavelist: [...state.globalLeavelist, action.payload],
      };

    case types.GET_GLOBAL_LEAVES:
      return { ...state, globalLeavelist: action.payload };

    case types.GET_SPECIFIC_GLOBAL_LEAVES:
      return { ...state, globalLeavedetails: action.payload };

    case types.UPDATE_GLOBAL_LEAVE:
      return {
        ...state,
        globalLeavelist: state.globalLeavelist.map((leave) =>
          leave.id === action.payload.id ? action.payload : leave
        ),
      };

    case types.DELETE_GLOBAL_LEAVE:
      const globalLeavelist = state.globalLeavelist.filter(
        (leave) => leave.id !== action.payload
      );
      return { ...state, globalLeavelist };

    default:
      return state;
  }
};

export default globalLeaveReducers;
